import { Components, Theme } from '@mui/material';

type MuiComponent = Components<Omit<Theme, 'components'>>;

const MuiButton: MuiComponent['MuiButton'] = {
  styleOverrides: {
    root: { gap: 8 }, // ! Not spacing value
  },
};

const MuiIconButton: MuiComponent['MuiIconButton'] = {
  defaultProps: { sx: { width: 'fit-content', height: 'fit-content' } },
};

const MuiPaper: MuiComponent['MuiPaper'] = {
  styleOverrides: {
    root: {
      backgroundImage: 'unset', // stop adding gradients material ui
    },
  },
};

const MuiToggleButtonGroup: MuiComponent['MuiToggleButtonGroup'] = {
  defaultProps: {
    sx: (theme) => ({
      '& .MuiToggleButtonGroup-grouped': {
        marginLeft: theme.distances.tiny,
        marginRight: theme.distances.tiny,
        border: 0,
        '&.Mui-disabled': {
          border: 0,
        },
        '&:not(:first-of-type)': {
          borderRadius: theme.shape.borderRadius,
        },
        '&:first-of-type': {
          borderRadius: theme.shape.borderRadius,
        },
      },
    }),
  },
};

const components: Components<Omit<Theme, 'components'>> = {
  MuiButton,
  MuiIconButton,
  MuiPaper,
  MuiToggleButtonGroup,
};

export { components };
